import { render, staticRenderFns } from "./RouteNotAuthorized.vue?vue&type=template&id=74a7e82a&"
import script from "./RouteNotAuthorized.vue?vue&type=script&lang=js&"
export * from "./RouteNotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./RouteNotAuthorized.vue?vue&type=style&index=0&id=74a7e82a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports